interface Pagination {
  itemsPerPage?: number;
  page?: number;
  sortBy: string[];
  sortDesc: boolean[];
}

interface Filter {
  field: string;
  operator: string;
  value: string;
  disabled?: boolean;
}

export function generateParams(pagination: Pagination, filters: Filter[], extraParams?: string[][]) {
  const params = new URLSearchParams(extraParams || [])
  if (pagination.itemsPerPage && pagination.page) {
    params.append('count', pagination.itemsPerPage.toString())
    params.append('offset', `${(pagination.page - 1) * pagination.itemsPerPage}`)
  }

  if (pagination.sortBy && pagination.sortBy.length) {
    params.append(`orderBy[${pagination.sortDesc[0] ? 'DESC' : 'ASC'}]`, pagination.sortBy[0])
  }

  filters.forEach((filter) => {
    if (!filter.disabled) {
      params.append(`${filter.field}[${filter.operator}]`, encodeURIComponent(filter.value))
    }
  })

  return params.toString()
}

export function getValidOperators(type: string) {
  switch (type) {
    case 'string':
      return stringOperators
    case 'date':
      return dateOperators
    case 'boolean':
    case 'enum':
      return enumOperators
    default:
      return operators
  }
}

export function getOperatorTitle(key: string) {
  return operators.find(o => o.key === key)?.text
}

const operators = [
  { text: 'Equals', key: 'eq' },
  { text: 'Not Equals', key: 'ne' },
  { text: 'Contains', key: 'lk' },
  { text: 'Greater than', key: 'gt' },
  { text: 'Greater than or equal to', key: 'gte' },
  { text: 'Less than', key: 'lt' },
  { text: 'Less than or equal to', key: 'lte' }
]

const stringOperators = [
  { text: 'Equals', key: 'eq' },
  { text: 'Not Equals', key: 'ne' },
  { text: 'Contains', key: 'lk' }
]

const dateOperators = [
  { text: 'Greater than', key: 'gt' },
  { text: 'Greater than or equal to', key: 'gte' },
  { text: 'Less than', key: 'lt' },
  { text: 'Less than or equal to', key: 'lte' }
]

const enumOperators = [
  { text: 'Equals', key: 'eq' },
  { text: 'Not Equals', key: 'ne' }
]
